// extracted by mini-css-extract-plugin
export default {"musicCardWrapper":"MusicShelfCardWrapper_musicCardWrapper__OK+nI"};